import { createContext } from "react";
import { Property, SsqSsqHeadingSsqProperty } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import { PropertyCommentState } from "./hooks/usePropertyComment";
import { AttachmentState } from "./hooks/usePropertyAttachment";
import { MenuItemType } from "src/components/ActionsPopover/ActionsPopover.types";
import { Post, PostElement } from "src/api/client-api/post/postSchema";
import { ElementsMapping } from "../../context/context";
import { UpdateProperty } from "src/api/client-api/property/useUpdateProperty";
import { DeleteProperty } from "src/api/client-api/property/useDeleteProperty";
import { ValidationMessage, ValidationSeverity } from "../validationTypes";
import { DataListValueOverride } from "src/api/client-api/dataListValueOverride/useGetAllDataListValueOverride";

export type PropertyUpdateOutcome = { saved: true } | { saved: false; messages: string[] };
export type PropertyUpdateHandler = (
    data: UpdateProperty,
    reportOutcome?: (outcome: PropertyUpdateOutcome) => void,
) => void;

export type PropertyOverrideMapping = Partial<Record<number, SsqSsqHeadingSsqProperty>>;

export type ScoreProperty = {
    scoreId: number;
    precision: number;

    // Example: 'pef';
    type: string;
};

export type ValidationState = {
    validationSeverity: ValidationSeverity | undefined;
    validationMessages: ValidationMessage[];
    propertyValidationKey: string;
    hasValidationMessages: boolean;
};

export type ElementsGroupByPosition = Partial<Record<number, PostElement[]>>;
export type ElementsGroups = {
    elementsGroupByPosition: ElementsGroupByPosition;
    maxPosition: number;
};

export type FormPropertyInitialValues = {
    score: ScoreProperty;

    post: Post;
    elementsByPropertyId: ElementsMapping;
    dataListValueOverrides: DataListValueOverride[];

    canEdit: boolean;
    changePost: () => void;

    onUpdate: PropertyUpdateHandler;
    onDelete: (data: DeleteProperty) => void;
    ssqSsqHeadingSsqProperty: SsqSsqHeadingSsqProperty;
    ssqVersionStructureId?: number | null;
    scoreUnit: string;
    allowComments: boolean;
    getValidationError: (propertyId: number, position: number) => ValidationState;

    getElement: {
        (propertyId: number, position: number): PostElement | undefined;
        (propertyId: number): PostElement[];
    };
    getElementsGroups: (properties: Property[]) => ElementsGroups;

    attachmentState: AttachmentState;
    commentState: PropertyCommentState;

    rowMenuAnchor: null | HTMLElement;
    setRowMenuAnchor: (anchor: HTMLElement | null) => void;

    menuItems: MenuItemType[];
    setMenuItems: (items: MenuItemType[]) => void;
};
export const FormPropertyContext = createContext<FormPropertyInitialValues | null>(null);
